import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';

const EffectiveDateEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ effectiveDate: value || null }));
      if (validationErrors.effectiveDate) {
        dispatch(clearValidationError('effectiveDate'));
      }
    }
  };

  if (!contract) return null;

  const displayValue = contract.effectiveDate ? 
    (typeof contract.effectiveDate === 'string' ? 
      contract.effectiveDate.split('T')[0] : 
      contract.effectiveDate) : '';

  return (
    <TextField
      label="Effective Date *"
      type="date"
      value={displayValue}
      onChange={(e) => handleChange(e.target.value)}
      variant="outlined"
      error={!!validationErrors.effectiveDate}
      helperText={validationErrors.effectiveDate}
      size="small"
      sx={{ width: '220px' }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default EffectiveDateEditor;
